import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import NetSuiteCredentialsStore from "../../../stores/credentials/net-suite-credentials-store";

interface IIntegrationProps {
    credentialsStore: NetSuiteCredentialsStore,
    vGroup: IValidationGroup,
}

const NetSuiteCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine
                label='Account ID'
                note='The value of NetSuite Account ID.'
                required
                key='accountId'
            >
                <Input
                    value={credentialsStore.accountId}
                    placeholder=''
                    onChange={v => credentialsStore.accountId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Client ID'
                note='The value of the client ID is provided when the integration record is created in NetSuite.'
                required
                key='clientId'
            >
                <Input
                    value={credentialsStore.clientId}
                    placeholder=''
                    onChange={v => credentialsStore.clientId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Client Secret'
                note='The value of the Client Secret is provided when the integration record is created in NetSuite.'
                required
                key='clientSecret'
            >
                <Input
                    value={credentialsStore.clientSecret}
                    placeholder=''
                    onChange={v => credentialsStore.clientSecret = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Default location Id'
                note='The ID of the default location, as configured on NetSuite dashboard'
                required
                key='locationId'
            >
                <Input
                    value={credentialsStore.locationId}
                    placeholder=''
                    onChange={v => credentialsStore.locationId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Default location name'
                note='The name of the default location, as configured on NetSuite dashboard'
                required
                key='locationId'
            >
                <Input
                    value={credentialsStore.locationName}
                    placeholder=''
                    onChange={v => credentialsStore.locationName = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default NetSuiteCredentials;
